import script from "./UserWelcome.vue?vue&type=script&setup=true&lang=js"
export * from "./UserWelcome.vue?vue&type=script&setup=true&lang=js"

import "./UserWelcome.vue?vue&type=style&index=0&id=1d1fb8a2&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1fb8a2"]])

export default __exports__